import request from '../utils/request';
/**
 * Validate a promo code against cart items
 */
export function validatePromoCode(data) {
    return request().post('/api/v1/promo-codes/validate/').send(data);
}
/**
 * Get list of available promo codes (for admin/debug purposes)
 */
export function getPromoCodes() {
    return request().get('/api/v1/promo-codes/').send();
}
/**
 * Get specific promo code details
 */
export function getPromoCode(id) {
    return request().get(`/api/v1/promo-codes/${id}/`).send();
}
/**
 * Get promo code usage history (admin only)
 */
export function getPromoCodeUsageHistory(id) {
    return request().get(`/api/v1/promo-codes/${id}/usage-history/`).send();
}
